import { json2csv } from "json-2-csv";
import { readData } from "../../firebase/database";
import styles from "./index.module.scss"

const Admin = () => {
  const handleDownload = async () => {
    try {
      let _data = await readData("/formData/");

      // Flatten the data
      const flattenedData = Object.keys(_data).map((key) => ({
        id: key,
        ..._data[key],
      }));

      // Convert to CSV
      const csv = json2csv(flattenedData);

      // Create a blob from the CSV and trigger the download
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "data.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // Clean up the URL object
    } catch (error) {
      // Handle error
      alert("There was an error downloading the CSV.");
      console.error(error);
    }
  };

  return (
    <div className={styles.container}>
      <button className={`btn`} onClick={handleDownload}>Download Data</button>
    </div >
  );
};
export default Admin;
